import type { TFunction } from 'i18next';
import type { DefaultTheme } from 'styled-components';
import type { MyAdCardActionsConfig } from '@/features/Profile/sections/MyAds/components/MyAdCardActions';
import type { Ad } from '@/api/types/common.types';
import { AdStatus } from '@/types';

export type MyAdCardActionHandlers = {
  advertise: (ad: Ad) => void;
  edit: (ad: Ad) => void;
  pay: (ad: Ad) => void;
  remove: (ad: Ad) => void;
  restore: (ad: Ad) => void;
};

export function getMyAdCardActionsConfig(
  status: AdStatus,
  t: TFunction,
  theme: DefaultTheme,
  handlers: MyAdCardActionHandlers
): MyAdCardActionsConfig | null {
  const actionsByStatus: Partial<Record<AdStatus, MyAdCardActionsConfig>> = {
    [AdStatus.Published]: {
      primaryAction: {
        label: t('common.advertise'),
        onClick: handlers.advertise,
      },
      menuActions: [
        {
          label: t('common.edit'),
          onClick: handlers.edit,
        },
        {
          label: t('common.remove'),
          onClick: handlers.remove,
          color: theme.palette.system.red,
        },
      ],
    },
    [AdStatus.AwaitingPayment]: {
      primaryAction: {
        label: t('common.pay'),
        onClick: handlers.pay,
      },
    },
    [AdStatus.Expired]: {
      primaryAction: {
        label: t('common.restore'),
        onClick: handlers.restore,
      },
    },
    [AdStatus.Pending]: {
      primaryAction: {
        label: t('common.advertise'),
        onClick: handlers.advertise,
      },
    },
    [AdStatus.Archived]: {
      primaryAction: {
        label: t('common.restore'),
        onClick: handlers.restore,
      },
    },
  };

  return actionsByStatus[status] ?? null;
}
